import React, { useContext } from "react";
import moment from "moment";
import PlatformContext from "./PlatformContext.jsx";
import SiteContext from "./SiteContext.jsx";
import SkipScreenshotFlag from "./SkipScreenshotFlag.jsx";
import TopBar from "./TopBar.jsx";

export default function Notification() {
  const { platform } = useContext(PlatformContext);
  const { hasNotify } = useContext(SiteContext);
  const previewFontClass = platform === "ios" ? "tw-font-previewIos" : "tw-font-previewAndroid";

  if (!hasNotify) {
    return (
      <>
        <SkipScreenshotFlag />
        <div className='tw-flex tw-h-[100svh]'>
          <p className='tw-m-auto'>This site doesn’t support notifications</p>
        </div>
      </>
    );
  }

  return (
    <>
      <TopBar title='Notifications' />

      <div className='tw-bg-grey-[#FAFAFA]'>
        <header className='tw-flex tw-flex-col tw-gap-1 tw-p-3 tw-pt-5'>
          <h2 className={`tw-m-0 tw-text-3xl tw-font-normal tw-leading-tight ${previewFontClass}`}>
            Road Closure - Expect Delays
          </h2>

          <p className='tw-m-0 tw-text-lg tw-font-normal tw-leading-tight tw-text-[#505050]'>
            West Main Street Closed from Bennet Dr to Corbett St for Tuesday through Friday
          </p>

          <p className='tw-m-0 tw-text-sm tw-leading-tight tw-text-[#808080]'>
            Published: {moment("2024-05-06 1:42 PM").format("MMM D, YYYY @ h:mm A")}
          </p>
        </header>

        <hr className='tw-h-[1px] tw-border-none tw-bg-[#DDD]' />

        <div className='tw-p-3'>
          <img
            src='/assets/appPreviews/map1.png'
            alt=''
            width='490'
            height='240'
            className='tw-bg-[var(--primary-color, black)] tw-block tw-h-auto tw-w-full'
          />

          <h3 className={`tw-m-0 tw-mt-2 tw-text-xl tw-font-medium tw-leading-tight ${previewFontClass}`}>
            Use Alternate Route!
          </h3>

          <p className='tw-m-0 tw-mt-2'>
            This letter serves as a notification for a scheduled temporary road closure due to construction from Bennet
            Dr to Corbett St.
          </p>

          <img
            src='/assets/appPreviews/map2.png'
            alt=''
            width='564'
            height='256'
            className='tw-m-0 tw-mt-2 tw-block tw-h-auto tw-w-full'
          />

          <p className='tw-m-0 tw-mt-2'>
            Please take all measures to avoid this road during the closure period. Route 27 is the recommended route
            into the town by{" "}
            <a href='#nowhere' className='tw-text-[#1565C0] tw-underline'>
              motor vehicle.
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
